// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__r-xJ0","alert":"SettungsInbox_alert__336QJ"};